import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FolioGuia } from "app/features/componentes/folioguia";

type Entity = models.FiltroPaquetesPPContrarecibos;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un Filtro
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdSucursalCobranza: validation.required,
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class FiltroComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onStatusChange = (x: models.FiltroGuiasContrarecibos) => {
        this.setState({ filtro: x });
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const Datetime = getField(kea.DateTime);
        const Cliente = getField(selectores.Cliente);
        const Sucursal = getField(selectores.Sucursal);
        const Folio = getField(FolioGuia);
        const StatusFacturacion = getField(selectores.StatusFacturacion);
        const StatusGuia = getField(selectores.StatusGuia);
        const SiNo = getField(selectores.SiNo);
        const StatusMultiple = getField(kea.Select);

        const status = models.StatusGuia;
        const items = Object.keys(status).filter(x => +x === +x).map(x => ({ value: +x, label: status[x] }));


        return (
            <div>
                {kea.autogrid(3, [
                    <Sucursal field="IdSucursalCobranza" label="Sucursal de cobranza" />,
                    <Cliente field="IdClientePaga" label="Cliente que paga el paquete prepagado" />,
                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/generarcontrarecibospp/filtro.tsx